import { SECOND } from "src/constants";

export const MAX_ANIMATION_DURATION = SECOND * 20;
export const MIN_ANIMATION_DURATION = SECOND * 2;
export const ANIMATION_LABEL = "Gift animation played";

export enum ANIMATION_FAILED_REASONS {
  ANIMATION_WAS_STOPPED_AUTOMATICALLY = "ANIMATION_WAS_STOPPED_AUTOMATICALLY",
  ERROR_ON_START_PLAYING = "ERROR_ON_START_PLAYING",
  VIDEO_ERROR = "VIDEO_ERROR",
}
